'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createLocationString = exports.formatClassTime = undefined;

var _querystring = require('querystring');

var formatClassTime = exports.formatClassTime = function formatClassTime(timestamp) {
  return new Date(timestamp * 1e3).toISOString().replace(/[-:]|(\.\d{3})/g, '');
};

var createLocationString = exports.createLocationString = function createLocationString(address) {
  var addressLine = address.address_line1,
      city = address.city,
      state = address.state,
      zipCode = address.zip_code;


  return [addressLine, city, state, zipCode].filter(Boolean).join(', ');
};

var createGoogleCalendarEventLink = function createGoogleCalendarEventLink(name) {
  var description = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var address = arguments[2];
  var starttime = arguments[3];
  var endtime = arguments[4];
  return 'https://www.google.com/calendar/render?action=TEMPLATE&' + (0, _querystring.stringify)({
    text: name,
    dates: formatClassTime(starttime) + '/' + formatClassTime(endtime),
    details: description,
    location: createLocationString(address)
  }) + '&sf=true&output=xml';
};

exports.default = createGoogleCalendarEventLink;